import { ProtocolEditor } from './ProtocolEditor'

export function App(): JSX.Element {
  return <ProtocolEditor />
}
